/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CashFromJSONTyped, CashToJSON, } from './Cash.js';
import { NonCashFromJSONTyped, NonCashToJSON, } from './NonCash.js';
import { PaymentCardFromJSONTyped, PaymentCardToJSON, } from './PaymentCard.js';
import { PointsFromJSONTyped, PointsToJSON, } from './Points.js';
export function FormOfPaymentFromJSON(json) {
    return FormOfPaymentFromJSONTyped(json, false);
}
export function FormOfPaymentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'cash':
            return Object.assign(Object.assign({}, CashFromJSONTyped(json, true)), { type: 'cash' });
        case 'non_cash':
            return Object.assign(Object.assign({}, NonCashFromJSONTyped(json, true)), { type: 'non_cash' });
        case 'payment_card':
            return Object.assign(Object.assign({}, PaymentCardFromJSONTyped(json, true)), { type: 'payment_card' });
        case 'points':
            return Object.assign(Object.assign({}, PointsFromJSONTyped(json, true)), { type: 'points' });
        default:
            throw new Error(`No variant of FormOfPayment exists with 'type=${json['type']}'`);
    }
}
export function FormOfPaymentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'cash':
            return CashToJSON(value);
        case 'non_cash':
            return NonCashToJSON(value);
        case 'payment_card':
            return PaymentCardToJSON(value);
        case 'points':
            return PointsToJSON(value);
        default:
            throw new Error(`No variant of FormOfPayment exists with 'type=${value['type']}'`);
    }
}
